<template>
  <div class="examination">
    <!-- 等考 -->
    <Header></Header>
    <Default></Default>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "@/components/header";
import Default from "@/components/default";
import Footer from "@/components/footer";
export default {
  name: 'Examination',
  components: { Header, Footer,Default },
  created(){
    sessionStorage.setItem("tabId",2)
  },
}
</script>

<style scoped>
.examination{
  width: 100%;
  height: 100vh;
  background: #171f30;
  overflow: auto;
}
</style>
